import { RouterStateSnapshot } from '@angular/router';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {RouterDataResolved} from '@ngxs/router-plugin';
import {Injectable} from '@angular/core';

export interface RtRouterDataResolverModel {
  url: string;
  params: {};
  queryParams: {};
  data: {};
}

@State<RtRouterDataResolverModel>({
  name: 'routerState',
  defaults: {
    url: '',
    params: {},
    queryParams: {},
    data: {},
  },
})
@Injectable()
export class RtRouterDataResolverState {
  @Selector()
  static url(state: RtRouterDataResolverModel): string {
    return state.url;
  }

  @Selector()
  static params(state: RtRouterDataResolverModel): {} {
    return state.params;
  }

  @Selector()
  static queryParams(state: RtRouterDataResolverModel): {} {
    return state.queryParams;
  }

  @Selector()
  static routeData(state: RtRouterDataResolverModel): {} {
    return state.data;
  }

  @Action(RouterDataResolved)
  resolveRouteData(ctx: StateContext<RtRouterDataResolverModel>, {routerState}: RouterDataResolved<any>) {
    const {
      url,
      root: {queryParams},
    } = routerState;

    let {root: route} = routerState;
    while (route.firstChild) {
      route = route.firstChild;
    }

    const {params, data} = route;

    ctx.patchState({
      url,
      params,
      queryParams,
      data,
    });
  }
}
